export enum ProjectRelationshipEnum {
  ArtistOrResponsibleWithPowers = 0,
  NoPowersJustTesting = 1,
  TeamMemberNoPowers = 2,
}
